import React from 'react';

import Badge from '@atlaskit/badge';

import {
  BadgeStyled,
  ContainerStyled,
  WrapperStyled,
} from './DragItemWrapper.styled';

type Props = {
  children: React.ReactNode;
  numberOfItems: number;
};

export function DragItemWrapper({
  children,
  numberOfItems,
}: Props): JSX.Element {
  return (
    <ContainerStyled>
      <WrapperStyled>{children}</WrapperStyled>
      {numberOfItems > 0 && (
        <BadgeStyled>
          <Badge appearance='primary' max={false}>
            {numberOfItems}
          </Badge>
        </BadgeStyled>
      )}
    </ContainerStyled>
  );
}
